interface DashboardHeaderProps {
    title: string;
    subtitle: string;
}

export function DashboardHeader({
    title,
    subtitle,
}: DashboardHeaderProps) {
    return (
        <div className="flex items-center justify-between border-b border-border px-6 py-4">
            <div>
                <h3 className="font-heading text-xl font-bold">
                    {title}
                </h3>

                <p className="mt-1 text-sm text-muted-foreground">
                    {subtitle}
                </p>
            </div>

            <div className="flex items-center gap-3">
                <div className="h-9 w-9 rounded-full bg-muted" />

                <div className="text-right">
                    <div className="h-2 w-20 rounded-full bg-muted" />

                    <div className="mt-2 h-2 w-12 rounded-full bg-muted" />
                </div>
            </div>
        </div>
    );
}